var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('router-link',{attrs:{"to":_vm.routerLink()}},[_c('span',[_vm._v(" "+_vm._s(_vm.prod.name)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }